__turbopack_context__.v({
  "fadeIn": "ProductMenuButtonAndOverlay-module__QSLloa__fadeIn",
  "menuButton": "ProductMenuButtonAndOverlay-module__QSLloa__menuButton",
  "overlay": "ProductMenuButtonAndOverlay-module__QSLloa__overlay",
  "polBtns": "ProductMenuButtonAndOverlay-module__QSLloa__polBtns",
  "polCloseBtn": "ProductMenuButtonAndOverlay-module__QSLloa__polCloseBtn",
  "polContent": "ProductMenuButtonAndOverlay-module__QSLloa__polContent",
  "polPrimary": "ProductMenuButtonAndOverlay-module__QSLloa__polPrimary",
  "polProductRow": "ProductMenuButtonAndOverlay-module__QSLloa__polProductRow",
  "polSecondaryRow": "ProductMenuButtonAndOverlay-module__QSLloa__polSecondaryRow",
  "polSubtitle": "ProductMenuButtonAndOverlay-module__QSLloa__polSubtitle",
  "polTitle": "ProductMenuButtonAndOverlay-module__QSLloa__polTitle",
  "productCard": "ProductMenuButtonAndOverlay-module__QSLloa__productCard",
  "secSubtitle": "ProductMenuButtonAndOverlay-module__QSLloa__secSubtitle",
  "secTitle": "ProductMenuButtonAndOverlay-module__QSLloa__secTitle",
});
